import { Link } from "wouter";
import { Button } from "@/components/ui/button";

const AboutSection = () => {
  const stats = [
    { value: "35+", label: "Years of Experience" },
    { value: "100K+", label: "Satisfied Farmers" },
    { value: "50+", label: "Seed Varieties" },
    { value: "12", label: "Research Facilities" }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <span className="text-primary font-medium">About Varsha Seeds</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-6 font-heading">
              Pioneering Agricultural Excellence Since 1985
            </h2>
            <p className="text-neutral-700 mb-4">
              Varsha Seeds has been at the forefront of agricultural innovation for over 
              three decades, providing farmers with high-quality seeds that maximize yield 
              and minimize environmental impact.
            </p>
            <p className="text-neutral-700 mb-6">
              Our journey began with a simple mission: to transform agriculture through 
              superior seed technology. Today, we're proud to serve farmers across the 
              country with seeds that represent the perfect balance of tradition and innovation.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              {stats.map((stat, index) => (
                <div key={index}>
                  <div className="text-3xl font-bold text-primary mb-1">{stat.value}</div>
                  <p className="text-neutral-700">{stat.label}</p>
                </div>
              ))}
            </div>
            
            <Link href="/about-us">
              <Button className="bg-primary hover:bg-primary/90 text-white rounded-full">
                Learn More About Us
              </Button>
            </Link>
          </div>
          
          <div className="order-1 lg:order-2 relative">
            <div className="relative z-10">
              <img 
                src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxfDB8MXxyYW5kb218MHx8ZmFybSBzZWVkcyBhbmQgY3JvcHN8fHx8fHwxNjk3ODM4ODI5&ixlib=rb-4.0.3&q=80&utm_campaign=api-credit&utm_medium=referral&utm_source=unsplash_source&w=600" 
                alt="Seed testing in laboratory" 
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-[80%] max-h-[80%] bg-accent -z-10 rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
